export default function() {

  function confirmLinkCancel(){
    $('#confirmLinkFormWrapper .cLinkCancel').off();
    $('#confirmLinkFormWrapper .cLinkProceed').off();
    $('#confirmLinkFormWrapper').remove();
    $('#overlay').removeClass('active dark');
    
    return false;
  }
  
  function confirmLink(cLSelector,cLTitle,cLText,cLDestination,cLNewWindow){
  
    var $cLink = $(cLSelector);
    //console.log('selector=%s, item=%s',cLSelector,$cLink.html());
    
    if($cLink.length!=1){
       return false;
    }
    if(cLDestination==''){
       return false;
    }
    
    //cL.href="";
    //$cLink.attr("href","javascript:return false;"); // prevent opening when clicked as stopPropagation and prevent Default not working on Android v1.0.9
    $cLink.click(function(e){
    e.stopPropagation();
    e.preventDefault(); // not working on some Android?
      
      
    var cForm = '<div id="confirmLinkFormWrapper"><div class="cLink">';
    cForm+='<div class="cLTitle">' + cLTitle+'</div>';
    cForm+='<div class="cLText">' + cLText+'</div>';

    var cLinkCancel = 'Cancel';
    
    var cLTarget=(cLNewWindow==true)?'_blank':'_self';
    var cLinkProceed = '<a class="cLAnchor" href="' + cLDestination+'" target="' + cLTarget +'" title="Proceed">Proceed</a>';
    

    cForm+='<div class="cLActions"><div class="cLinkCancel">' + cLinkCancel + '</div><div class="cLinkProceed">' + cLinkProceed + '</div></div>';
    cForm += '</div></div>';
    $('body').append(cForm);
    $('#confirmLinkFormWrapper .cLinkCancel').click(function(){
      confirmLinkCancel();
    });
      $('#confirmLinkFormWrapper .cLinkProceed').click(function(){
      confirmLinkCancel();
    });
    
    $('#confirmLinkFormWrapper .cLinkProceed .cLAnchor').attr('href',cLDestination);
    
    
    $('#overlay').addClass('active dark');
    return false;
    });
  }

  var  geText = "You have clicked on the link to the BAT <b>Gifts & Entertainment Tracker</b>. Please note that this will open in a new browser window.<br><br>You can also access the G&E Tracker directly on <b>www.bat.com/ge</b>, but you must be on the BAT Network.<br><br>Any issues or questions regarding the Tracker, should be emailed to <b>sobc_support@bat.com</b>.<br><br>Click 'Proceed' to carry on to the Tracker, or 'Cancel'.";


  confirmLink('a[href="https://www.bat.com/ge"]','G&E Tracker',geText,'https://www.bat.com/ge',true);
  // G&E policy page link
  // confirmLink('.obj29 a[href="https://www.bat.com/ge"]','G&E Tracker',geText,'https://www.bat.com/ge',true);
}